import type { ReactElement } from 'react';
import React from 'react';

import { FeatureFlag } from '@swf/core/enums';
import useFeature from '@swf/core/hooks/useFeature';
import type { HGPokerGameTile } from '@swf/core/types/Poker';
import { TileType } from '@swf/core/types/Poker';
import { GameTile, PokerGameTile } from '@swf/poker';

import DeleteGameButton from '../PokerGameTile/DeleteGame/DeleteGameButton';

import styles from './GameTileSection.scss';

export interface Props {
  title: ReactElement;
  games: HGPokerGameTile[];
  type: TileType.Registered | TileType.Upcoming | TileType.Cash | TileType.Recent;
}

const GameTileSection: React.FC<Props> = ({ title, games, type }) => {
  const gameTilesFeatureFlag = useFeature(FeatureFlag.PKRGameTiles);

  return (
    <section className={styles.container}>
      <div className={styles.title}>
        <p>{title}</p>
        {type !== TileType.Recent && <DeleteGameButton games={games} />}
      </div>
      <div
        className={
          gameTilesFeatureFlag ? styles.gamesInnerContainerFlagOn : styles.gamesInnerContainer
        }
        data-testid={`${type}-game-container`}
      >
        {games?.map((game: HGPokerGameTile) =>
          gameTilesFeatureFlag ? (
            <GameTile key={game.id} {...game} data-testid="game-item" />
          ) : (
            <PokerGameTile key={game.id} {...game} data-testid="game-item" />
          )
        )}
      </div>
    </section>
  );
};

export default GameTileSection;
